import {type BottomSheetViewProps} from './BottomSheet.types'

export function BottomSheet(_: BottomSheetViewProps) {
  throw new Error('BottomSheet is not available on web')
}
